import { ComponentProps, FC } from 'react';
import classNames from 'clsx';
import styles from './Skeleton.module.scss';

export const SkeletonBanner: FC<ComponentProps<'div'>> = ({ className, ...props }) => {
  return (
    <div
      className={classNames(styles.box, className)}
      {...props}
    >
      <div className={classNames('ssc', styles.groupLines)}>
        <div className="ssc-head-line w-40"></div>
        <div className={classNames('ssc-line w-80', styles.line)}></div>
        <div className={classNames('ssc-line w-60', styles.line)}></div>
        <div className={classNames('ssc-head-line', styles.thickLine)}></div>
      </div>
    </div>
  );
};
